import { B2B_PACKAGE_MANAGEMENT, PARTNER_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { PartnerManagementRequestModel } from "./model/PartnerManagementRequestModel";
import { PartnerManagementResponseModel } from "./model/PartnerManagementResponseModel";
import { CreatePartnerRequestModel } from "./model/create/CreatePartnerRequestModel";
import { CreatePartnerResponseModel } from "./model/create/CreatePartnerResponseModel";
import { PartnerManagementDetailResponseModel } from "./model/detail/PartnerManagementDetailResponseModel";
import { UpdatePartnerRequestModel } from "./model/update/UpdatePartnerRequestModel";

export interface IPartnerManagementRepository {
  getList(
    params: PartnerManagementRequestModel,
  ): Promise<BaseApiResponseModel<PartnerManagementResponseModel[]>>;
  getB2BList(
    params: PartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<PartnerManagementResponseModel>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerManagementDetailResponseModel>>;
  createPartner(
    body: CreatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<CreatePartnerResponseModel>>;
  updatePartner(
    body: UpdatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<PartnerManagementDetailResponseModel>>;
  deletePartner(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerManagementResponseModel>>;
}

@injectable()
export class PartnerManagementImpl implements IPartnerManagementRepository {
  async getList(
    params: PartnerManagementRequestModel,
  ): Promise<BaseApiResponseModel<PartnerManagementResponseModel[]>> {
    return await client?.get(PARTNER_MANAGEMENT?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerManagementDetailResponseModel>> {
    return await client?.get(PARTNER_MANAGEMENT?.DETAIL, params);
  }

  async getB2BList(
    params: PartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<PartnerManagementResponseModel>> {
    return await client?.get(B2B_PACKAGE_MANAGEMENT.B2B_PARTNER_LIST, params);
  }

  async updatePartner(
    body: UpdatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<PartnerManagementDetailResponseModel>> {
    return await client?.put(`${PARTNER_MANAGEMENT?.UPDATE}`, body);
  }

  async createPartner(
    body: CreatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<CreatePartnerResponseModel>> {
    return await client?.post(PARTNER_MANAGEMENT?.CREATE, body);
  }

  async deletePartner(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerManagementResponseModel>> {
    return await client?.delete(PARTNER_MANAGEMENT.DELETE, params);
  }
}
